module.exports = __webpack_public_path__ + "static/media/emp_management.de00845c.svg";